import script from "./VcfsTrialBalancePopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./VcfsTrialBalancePopUp.vue?vue&type=script&setup=true&lang=ts"

import "./VcfsTrialBalancePopUp.vue?vue&type=style&index=0&id=e09c1a3a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e09c1a3a"]])

export default __exports__